var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatAttachmenti = function SvgChatAttachmenti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M10.32 16.498a2.75 2.75 0 0 1-1.406-.388 2.9 2.9 0 0 1-1.035-3.924l.85-1.488a.426.426 0 0 1 .592-.163.45.45 0 0 1 .16.6l-.863 1.489a2.033 2.033 0 0 0 .728 2.738 1.97 1.97 0 0 0 2.688-.738l2.43-4.276a1.29 1.29 0 0 0 .123-1 1.31 1.31 0 0 0-.6-.8 1.29 1.29 0 0 0-1.776.488l-2.359 4.138a.638.638 0 0 0 .715.938.58.58 0 0 0 .382-.3l2.121-3.726a.426.426 0 0 1 .592-.163.44.44 0 0 1 .16.6l-2.125 3.726a1.46 1.46 0 0 1-.913.713 1.5 1.5 0 0 1-1.135-.15 1.54 1.54 0 0 1-.552-2.076l2.358-4.138a2.16 2.16 0 0 1 3.971.538 2.23 2.23 0 0 1-.21 1.662l-2.442 4.264a2.8 2.8 0 0 1-2.454 1.436"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatAttachmenti);
export default ForwardRef;